var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacialrecognition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99998 1.33301H3.33331C2.22875 1.33301 1.33331 2.22844 1.33331 3.33301V5.33301H2.66665V3.33301C2.66665 2.96482 2.96513 2.66634 3.33331 2.66634H5.99998V1.33301Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.66634V1.33301H12.6667C13.7713 1.33301 14.6667 2.22844 14.6667 3.33301V5.33301H13.3334V3.33301C13.3334 2.96482 13.0349 2.66634 12.6667 2.66634H10.6667Z",
    fill: "#344054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 13.3337H12.6667C13.0349 13.3337 13.3334 13.0352 13.3334 12.667V10.667H14.6667V12.667C14.6667 13.7716 13.7713 14.667 12.6667 14.667H10.6667V13.3337Z",
    fill: "#344054"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66665 10.667V12.667C2.66665 13.0352 2.96513 13.3337 3.33331 13.3337H5.99998V14.667H3.33331C2.22875 14.667 1.33331 13.7716 1.33331 12.667V10.667H2.66665Z",
    fill: "#344054"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33355 5.33301C8.70175 5.33301 9.00022 5.63148 9.00022 5.99967V8.66634C9.00022 8.95327 8.81655 9.20807 8.54435 9.29881L7.54435 9.63214C7.19508 9.74854 6.81748 9.55981 6.70108 9.21047C6.58464 8.86121 6.77342 8.48367 7.12268 8.36721L7.66688 8.18581V5.99967C7.66688 5.63148 7.96535 5.33301 8.33355 5.33301Z",
    fill: "#344054"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00275 10.1953C5.74241 9.93492 5.32029 9.93492 5.05995 10.1953C4.7996 10.4556 4.7996 10.8777 5.05995 11.138C6.68387 12.762 9.3168 12.762 10.9407 11.138C11.2011 10.8777 11.2011 10.4556 10.9407 10.1953C10.6804 9.93492 10.2583 9.93492 9.99793 10.1953C8.89473 11.2985 7.106 11.2985 6.00275 10.1953Z",
    fill: "#344054"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 5.99967C4.66669 5.63148 4.96517 5.33301 5.33335 5.33301C5.70154 5.33301 6.00002 5.63149 6.00002 5.99967V6.66634C6.00002 7.03454 5.70154 7.33301 5.33335 7.33301C4.96517 7.33301 4.66669 7.03454 4.66669 6.66634V5.99967Z",
    fill: "#344054"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 5.33301C10.2985 5.33301 10 5.63148 10 5.99967V6.66634C10 7.03454 10.2985 7.33301 10.6667 7.33301C11.0349 7.33301 11.3333 7.03454 11.3333 6.66634V5.99967C11.3333 5.63149 11.0349 5.33301 10.6667 5.33301Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacialrecognition);
export default __webpack_public_path__ + "static/media/Facial recognition.dc2fe672aec590396a839e040ecc85e5.svg";
export { ForwardRef as ReactComponent };